/**
 * @generated SignedSource<<763d7e9510b79b6e949e27a32d6a46d0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider$data = {
  readonly conditionalFormattingRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly expression: {
          readonly __typename: "JiraFormattingMultipleValueOperand";
          readonly fieldId: string;
          readonly values: ReadonlyArray<string>;
        } | {
          readonly __typename: "JiraFormattingNoValueOperand";
          readonly fieldId: string;
        } | {
          readonly __typename: "JiraFormattingSingleValueOperand";
          readonly fieldId: string;
          readonly value: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider";
};
export type entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider$key = {
  readonly " $data"?: entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider$data;
  readonly " $fragmentSpreads": FragmentRefs<"entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "fieldId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "JiraFormattingRuleConnection",
      "kind": "LinkedField",
      "name": "conditionalFormattingRules",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraFormattingRuleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraFormattingRule",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "expression",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ],
                      "type": "JiraFormattingSingleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "values"
                        }
                      ],
                      "type": "JiraFormattingMultipleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "type": "JiraFormattingNoValueOperand"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "31a078cda2cbef262e87df8f16169099";

export default node;
